interface tokenData {
  sub: string
  email: string
  iat: number
  exp: number
}

export const parseJwt = (token: string): tokenData => {
  const base64Url: string = token.split('.')[1]!
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = Buffer.from(base64, 'base64').toString()

  return JSON.parse(jsonPayload)
}
